import styled from "styled-components";
import { handleTopSpacing, handleBottomSpacing } from "helpers/spacingAndFonts";

export const ButtonContainer = styled.div`
    ${handleTopSpacing({ topSpacing: "2xl" })}
    text-align: center;
`;
